const config = {
  isProd: true,
  directServerHost: '111.229.80.138:8888',
  directServerAddr: 'http://111.229.80.138:8888',
  prodServerHost: 'file.zhoushoujian.com',
  prodServerAddr: 'https://file.zhoushoujian.com',
};

export default config;
